'use client';
import { Provider } from 'react-redux';
import { applyMiddleware, compose, legacy_createStore as createStore } from 'redux';
import thunk from 'redux-thunk';
import reducers from './_components/_reducers';

import { useNewTranslationRequest } from 'providers/ClientProviders/useNewTranslationRequest';
import { useEffect, useMemo, useState } from 'react';
import OrderingForm from './_components/OrderingForm';

import { IntegrationEnum, QualityEnum } from 'gql/graphql';

import { dialects } from 'constants/dialects';
import { usePathname } from 'next/navigation';
import 'styles/legacy/application-tr.scss';
import 'styles/legacy/font.scss';

const composeEnhancers = compose;

export type TInputs = {
  sourceLanguageCode: string;
  targetLanguageCodes: string[];
  quality: QualityEnum;
  contextUrl: string;
  callbackUrl: string;
  name: string;
  charLimit: Record<string, string>;
  copy: string;
  autoClientReview: boolean;
  sendCompletionEmail: boolean;
  htmlAllowed: boolean;
  styleGuideReferenceId: string;
  purchaseOrderCode: string;
  integration?: IntegrationEnum | undefined;
  selectedEditors: {
    generalEditor: string;
    languageEditors: object;
    perLanguage: boolean;
  };
  proposedClientDeadline: string | null;
  comment: string;
  excluded: string[];
  workflowId: string;
};

const TranslationRequestsNewPage = () => {
  const initialInputs: TInputs = useMemo(
    () => ({
      sourceLanguageCode: '',
      targetLanguageCodes: [],
      quality: QualityEnum.Localization,
      contextUrl: '',
      name: '',
      charLimit: {},
      copy: '',
      autoClientReview: false,
      sendCompletionEmail: false,
      htmlAllowed: true,
      callbackUrl: '',
      styleGuideReferenceId: '',
      purchaseOrderCode: '',
      selectedEditors: {
        generalEditor: '',
        languageEditors: {},
        perLanguage: false
      },
      proposedClientDeadline: null,
      comment: '',
      excluded: [],
      workflowId: ''
    }),
    []
  );

  const { data, isFetched } = useNewTranslationRequest();
  const [store, setStore] = useState<any>(
    createStore(
      reducers,
      { staticData: {}, inputs: initialInputs, wouldNeedDetails: false },
      composeEnhancers(applyMiddleware(thunk))
    )
  );
  const pathname = usePathname();
  const addon = pathname.split('/translation/new/')?.at(1);

  useEffect(() => {
    if (isFetched) {
      const inputs = {
        ...initialInputs,
        styleGuideReferenceId: data?.styleGuides?.at(0)?.referenceId
      };

      setStore(
        createStore(
          reducers,
          {
            staticData: {
              ...data,
              targetLanguageCodes: [IntegrationEnum.Hubspot, IntegrationEnum.Hubdb].includes(
                addon as IntegrationEnum
              )
                ? [...(data?.targetLanguageCodes ?? []), ...dialects]
                : data?.targetLanguageCodes
            },
            inputs,
            wouldNeedDetails: data?.wouldNeedDetails
          },
          composeEnhancers(applyMiddleware(thunk))
        )
      );
    }
  }, [data, initialInputs, isFetched, addon]);

  return (
    <div className="pt-10">
      <Provider store={store}>
        <OrderingForm />
      </Provider>
    </div>
  );
};

export default TranslationRequestsNewPage;
